// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.articlesContent_E8vtg {
  display: flex;
  flex-direction: column;

  ul {
    margin: 0;
  }
  .article_p9ZBz {
    .articleTitle_dHNEq,
    .articleInfo_R_aZI {
      color: #1a1a1a;
      font-weight: 400;
    }
    .articleTitle_dHNEq {
      margin: 15px 0;
      font-weight: 300;
      cursor: pointer;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      svg {
        transform: rotate(-90deg);
        -webkit-transform: rotate(-90deg);
        -moz-transform: rotate(-90deg);
        -ms-transform: rotate(-90deg);
        -o-transform: rotate(-90deg);
      }
    }
    .articleInfo_R_aZI {
      margin: 20px 0;
      interpolate-size: allow-keywords;
      transition: all 300ms;
      -webkit-transition: all 300ms;
      -moz-transition: all 300ms;
      -ms-transition: all 300ms;
      -o-transition: all 300ms;
    }
  }
}

.YourAccountConfigIcons_XQXfR {
  display: flex;
  align-items: center;
  gap: 10px;
}
.ConectionsGrayIcon_d1WBw {
  width: fit-content;
  margin: 0 auto;
}
.iconsLogoContainer_dOFNJ {
  margin: 10px auto;
  width: fit-content;
}
.iconLogos_gNSez {
  display: inline-block;
  svg {
    height: 50px;
    width: 50px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/HelpPage/Apps/Apps.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;;EAEtB;IACE,SAAS;EACX;EACA;IACE;;MAEE,cAAc;MACd,gBAAgB;IAClB;IACA;MACE,cAAc;MACd,gBAAgB;MAChB,eAAe;MACf,WAAW;MACX,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B;QACE,yBAAyB;QACzB,iCAAiC;QACjC,8BAA8B;QAC9B,6BAA6B;QAC7B,4BAA4B;MAC9B;IACF;IACA;MACE,cAAc;MACd,gCAAgC;MAChC,qBAAqB;MACrB,6BAA6B;MAC7B,0BAA0B;MAC1B,yBAAyB;MACzB,wBAAwB;IAC1B;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB;IACE,YAAY;IACZ,WAAW;EACb;AACF","sourcesContent":[".articlesContent {\n  display: flex;\n  flex-direction: column;\n\n  ul {\n    margin: 0;\n  }\n  .article {\n    .articleTitle,\n    .articleInfo {\n      color: #1a1a1a;\n      font-weight: 400;\n    }\n    .articleTitle {\n      margin: 15px 0;\n      font-weight: 300;\n      cursor: pointer;\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      svg {\n        transform: rotate(-90deg);\n        -webkit-transform: rotate(-90deg);\n        -moz-transform: rotate(-90deg);\n        -ms-transform: rotate(-90deg);\n        -o-transform: rotate(-90deg);\n      }\n    }\n    .articleInfo {\n      margin: 20px 0;\n      interpolate-size: allow-keywords;\n      transition: all 300ms;\n      -webkit-transition: all 300ms;\n      -moz-transition: all 300ms;\n      -ms-transition: all 300ms;\n      -o-transition: all 300ms;\n    }\n  }\n}\n\n.YourAccountConfigIcons {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.ConectionsGrayIcon {\n  width: fit-content;\n  margin: 0 auto;\n}\n.iconsLogoContainer {\n  margin: 10px auto;\n  width: fit-content;\n}\n.iconLogos {\n  display: inline-block;\n  svg {\n    height: 50px;\n    width: 50px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"articlesContent": `articlesContent_E8vtg`,
	"article": `article_p9ZBz`,
	"articleTitle": `articleTitle_dHNEq`,
	"articleInfo": `articleInfo_R_aZI`,
	"YourAccountConfigIcons": `YourAccountConfigIcons_XQXfR`,
	"ConectionsGrayIcon": `ConectionsGrayIcon_d1WBw`,
	"iconsLogoContainer": `iconsLogoContainer_dOFNJ`,
	"iconLogos": `iconLogos_gNSez`
};
export default ___CSS_LOADER_EXPORT___;
